import axios from 'axios';

export class ErrorUtils {
  /**
   * Extracts a human-readable error message from a caught error.
   *
   * Priority:
   * 1. `error.response.data.message` — the API‑provided message
   * 2. `error.response.data` if it is a plain string
   * 3. `error.message` — the generic Axios / JS error message
   * 4. The provided fallback string
   */
  static getApiErrorMessage(
    error: unknown,
    fallback = 'An unexpected error occurred'
  ): string {
    if (axios.isAxiosError(error)) {
      const data = error.response?.data;

      if (data?.message) {
        return Array.isArray(data.message)
          ? data.message.join(', ')
          : String(data.message);
      }

      if (typeof data === 'string' && data.length > 0) {
        return data;
      }
    }

    if (error instanceof Error) {
      return error.message;
    }

    return fallback;
  }
}
